import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";
import { toast } from "react-toastify";

// Stages
export const listChecklistStages = createAsyncThunk(
  "checklist/stages/list",
  async () => {
    try {
      const res = await Api.get(`checklist/stages`);
      if (res.data.status_code === 200) return res.data.data;
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);

export const createChecklistStage = createAsyncThunk(
  "checklist/stages/create",
  async (payload) => {
    try {
      const res = await Api.post(`checklist/stages`, payload);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return res.data.data;
      }
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);

export const updateChecklistStage = createAsyncThunk(
  "checklist/stages/update",
  async ({ id, data }) => {
    try {
      const res = await Api.put(`checklist/stages/${id}`, data);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return res.data.data;
      }
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);

export const deleteChecklistStage = createAsyncThunk(
  "checklist/stages/delete",
  async (id) => {
    try {
      const res = await Api.delete(`checklist/stages/${id}`);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return { id };
      }
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);

// Templates
export const listChecklistTemplates = createAsyncThunk(
  "checklist/templates/list",
  async () => {
    try {
      const res = await Api.get(`checklist/templates`);
      if (res.data.status_code === 200) return res.data.data;
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);

export const createChecklistTemplate = createAsyncThunk(
  "checklist/templates/create",
  async (payload) => {
    try {
      const res = await Api.post(`checklist/templates`, payload);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return res.data.data;
      }
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);

export const updateChecklistTemplate = createAsyncThunk(
  "checklist/templates/update",
  async ({ id, data }) => {
    try {
      const res = await Api.put(`checklist/templates/${id}`, data);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return res.data.data;
      }
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);

export const deleteChecklistTemplate = createAsyncThunk(
  "checklist/templates/delete",
  async (id) => {
    try {
      const res = await Api.delete(`checklist/templates/${id}`);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return { id };
      }
      toast.error(res.data.message);
    } catch (e) {
      toast.error(e.message);
    }
  }
);
